export default String.raw`
<div class="message-popup-background container-to-delete-js">
	<div class="change-data-container employee">
		<div class="data-form">
			<div class="data-form__header">
				{{translations.AddEmployee}}
				<button class="close-button cancel-js" aria-label="{{ translations.Close }}">
					<svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
				</button>
			</div>
			<div class="form-js form-into-data-js" data-success="{{ translations.WorkerAccountHasBeenAdded }}" data-error="{{ translations.EmployeeWithThatEmailExists }}" data-email="{{customer.Email}}">
				<input type='hidden' name='__action' value='Customer/EmployeeAdd'>
				<div class="form__input-wrapper">
					<label for="email" data-type="email" class="form__input-info input-info-js"><span class="required">* </span>{{translations.Email}}</label>
					<input id="email" class="form__input-value input-value-js onlyInputEventValidation" type='email' name='email' maxlength="50" autocomplete="email" required>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
					<div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
				</div>
				<div class="required-fields"><span class="required">*</span> {{ translations.RequiredFields }}</div>
				<button class="primary-action-button closing-modal-mobile-js add-new-employee-js replace-template-js" data-container=".employees-list-view-js" data-template="partials/customer-profile/employees-list/employees-view-lis.html">
					{{translations.AddEmployee}}
				</button>
			</div>
		</div>
	</div>
</div>
`